import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./app/reportWebVitals";
import {Provider} from "react-redux";
import {store} from "./app/store";
import {App} from "./app/App";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
root.render(
    <Provider store={store}>
        <App/>
    </Provider>
);

reportWebVitals();